import { useState } from "react";
import { api } from "../../../core/services/api";

interface SignedUrl {
  path: string;
  url: string;
}

export const useSignedUrl = () => {
  const token = localStorage.getItem("token");
  const [signedUrls, setSignedUrls] = useState<SignedUrl | null>(null);

  const getAssignedUrl = async (path: string) => {
    try {
      const response = await api.post(
        `/file/uploadUrl`,
        {
          path: path,
        },
        {
          headers: {
            Authorization: token || "",
          },
        }
      );

      if (response.status !== 200) {
        console.error("Erro na resposta da API:", response.status);
        throw new Error("Erro ao buscar URL de upload");
      }

      setSignedUrls(response.data);

      return response.data;
    } catch (error) {
      console.error("Erro ao obter URL assinada:", error);
      throw error;
    }
  };

  return {
    getAssignedUrl,
    signedUrls,
  };
};
